import store from "@/state/store";

const tasks = [
    {
        repeatAfterSeconds: 60000 * 2, // 60 seconds * 2
        handler() {
            const loggedIn = store.getters['auth/loggedIn'];
            if (loggedIn) {
                store.dispatch('notifications/getTopbarNotifications').then();
            }
        },
    }
];

export default tasks
